import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function MidCTA() {
  return <section className="py-20 px-4 bg-cream border-y border-cream-dark" data-id="element-239" data-mp="3owgd5yvzoaw1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-240" data-mp="3jzg37cw0qnzn">
        <h2 className="text-3xl font-serif font-bold text-green mb-8" data-id="element-241" data-mp="3fx3251s7ve97">
          Todo lo que recibís en un solo lugar
        </h2>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gold/30 mb-8 inline-block text-left" data-id="element-242" data-mp="ggwjwzvbisgz">
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3" data-id="element-243" data-mp="bk63ucjijwvk">
            {['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Bono 1 — Inocuidad y Seguridad Alimentaria', 'Bono 2 — Métodos de Conservación', 'Bono 3 — Materias Primas y Calidad', 'Bono 4 — Procesos Alimentarios Paso a Paso', 'Bono 5 — Diccionario Profesional Técnico', 'Banco de paquete de actividades adicionales', 'Banco de Evaluaciones', 'Acceso inmediato', 'Pago único', 'Garantía de 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-244" data-mp="eddar3x4wa0o" data-mpi={i}>
                <Check size={16} className="text-terracota shrink-0" data-id="element-245" data-mp="jcpxzprx3j3s" />
                <span className="text-sm text-ink font-medium" data-id="element-246" data-mp="je14hxcqz4yl">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="mb-8" data-id="element-247" data-mp="9ea5bid8s1s6">
          <p className="text-slate mb-2" data-id="element-248" data-mp="9fl93i6ot9ja">Todo por un único pago de:</p>
          <p className="text-5xl font-bold text-green mb-2" data-id="element-249" data-mp="1ytq5w9d3of6g">USD 19,90</p>
          <p className="text-sm text-terracota font-medium" data-id="element-250" data-mp="1yrnfvpby6m1q">
            Precio promocional disponible por tiempo limitado
          </p>
        </div>

        <Button href="#pricing" variant="green" className="mb-4" data-id="element-251" data-mp="22cfemp1tqs4m">
          QUIERO MI MEGA PACK AHORA
        </Button>

        <div className="flex justify-center gap-4 text-xs text-slate font-medium" data-id="element-252" data-mp="1xaq5jey5woj6">
          <span data-id="element-253" data-mp="1sdzoopej9owp">🔒 Pago seguro</span>
          <span data-id="element-254" data-mp="1sfaueurjh6qg">⚡ Acceso inmediato</span>
          <span data-id="element-255" data-mp="1ocefpf54durs">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}